import request from '@/utils/request';

export function receiveCouponDetail(code, id) {
  return request({
    url: '/CouponCollect/detail',
    params: {
      code,
      id,
    },
  });
}

export function receiveCouponJoin(code, id, mobile, smsCode, silentRequest = true) {
  return request({
    url: '/CouponCollect/join',
    method: 'POST',
    data: {
      code,
      id,
      mobile,
      sms_code: smsCode,
    },
    silentRequest,
  });
}
